import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_SHOP_FAIL = "SHOP:UPSERT_SHOP_FAIL";

export const upsertShopFailAction = (
  organization: OrganizationKeyName,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_SHOP_FAIL as typeof UPSERT_SHOP_FAIL,
  organization,
  errors,
  id,
});

export type UpsertShopFail = ReturnType<typeof upsertShopFailAction>;
